import AjaxClass from '@/ajax'

export default class StudentService {
  ajax

  constructor (store) {
    this.ajax = new AjaxClass(store)
  }

  getList (then, params) {
    return this.ajax.get('/student', params, (data) => {
      return then(data)
    })
  }

  getItem (id, then, params) {
    return this.ajax.get('/student/' + id, params, (data) => {
      return then(data)
    })
  }

  saveItem (item, update, then) {
    return this.ajax.post('/student/save', {item: item, update: update}, (data) => {
      then(data)
    })
  }

  deleteItem (id, then) {
    return this.ajax.post('/student/delete', {id: id}, (data) => {
      then(data)
    })
  }

  static getDefaultItem () {
    return {
      id: '',
      uin: '',
      group: {
        id: ''
      },
      password: '',
      testStudentAnswers: [],
      thematicStudentAnswers: [],
      practiceStudentAnswers: []
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/StudentService.js